import { useNavigate } from "react-router-dom";
import CustomButton from "src/components/common/CustomButton";
import "./CreativePowerSection.css";

const CreativePowerSection = () => {
  const navigate = useNavigate();

  const handleOrderClick = () => {
    navigate("/products");
    window.scrollTo(0, 0);
  };

  const handleDTFClick = () => {
    navigate("/products/dtf-heat-transfers");
    window.scrollTo(0, 0);
  };

  const orderGangSheet = () => {
    navigate("/products/dtf-transfers-by-gang-sheet");
    window.scrollTo(0, 0);
  };

  const handleQuoteClick = () => {
    navigate("/contact");
    window.scrollTo(0, 0);
  };

  return (
    <>
      <section className="creative-power-section">
        <h2 className="creative-power-title">UNLEASH YOUR CREATIVE POWER</h2>

        <div className="creative-power-button-wrapper">
          <CustomButton link="/products/dtf-heat-transfers" className="hero-carousel-button hero-carousel-button-primary mx-2" onClick={handleDTFClick}>
            Order Transfers by Size
          </CustomButton>
          <CustomButton link="/products/dtf-transfers-by-gang-sheet" className="hero-carousel-button hero-carousel-button-primary mx-2" onClick={orderGangSheet}>
            Order Gang Sheet
          </CustomButton>
        </div>

        <div className="creative-power-content">
          <div className="creative-power-image">
            <img src="https://wemust-nest.s3.ca-central-1.amazonaws.com/1773241207324_467418593_17954650277845840_7397797998248278447_n.jpg"
              alt="DTF Printer"
            />
          </div>
          <div className="creative-power-image">
            <img
              src="https://wemust-nest.s3.ca-central-1.amazonaws.com/1773241227862_467479284_17954650301845840_7063019377651326807_n.jpg"
              alt="Workshop"
            />
          </div>
        </div>
      </section>

      {/* Get In Touch Section */}
      <section className="get-in-touch-section">
        <div className="get-in-touch-wrapper">
          <div className="get-in-touch-main">
            <h2 className="get-in-touch-title">Get In Touch</h2>
            <p className="get-in-touch-text">
              Questions about an order? Need help with artwork or production? Our team is here to make printing simple. From DTF transfers to screen print transfers, patches, and blanks, we work with you to get it right — fast, accurate, and ready for production. Get in touch anytime and let’s move your project forward.
            </p>

            <div className="get-in-touch-image-grid">
              <div className="">
                <div className="nr-4">
                  <img src="https://wemust-nest.s3.ca-central-1.amazonaws.com/1751179623590_GetInTouchImage1.png" alt="Design 1" />
                </div>
                <div className="">
                  <img src="https://wemust-nest.s3.ca-central-1.amazonaws.com/1751179633666_GetInTouchImage2.png" alt="Design 4" />
                </div>
              </div>
              <div className="">
                <div className="nr-4">
                  <img src="https://wemust-nest.s3.ca-central-1.amazonaws.com/1751179640253_GetInTouchImage3.png" alt="Design 1" />
                </div>
                <div className="">
                  <img src="https://wemust-nest.s3.ca-central-1.amazonaws.com/1751179650807_GetInTouchImage4.png" alt="Design 4" />
                </div>
              </div>
              <div className="small_tr4">
                <div className="nr-4">
                  <img src="https://wemust-nest.s3.ca-central-1.amazonaws.com/1751179657167_GetInTouchImage5.png" alt="Design 1" />
                </div>
                <div className="">
                  <img src="https://wemust-nest.s3.ca-central-1.amazonaws.com/1766067051540_1.png" alt="Design 4" />
                </div>
              </div>
            </div>

            <div className="get-in-touch-button-wrapper">
              <CustomButton link="/contact" className="get-in-touch-button" onClick={handleQuoteClick}>
                Request a Quote
              </CustomButton>
            </div>
          </div>

          <div className="get-in-touch-offices">
            <div className="office-item">


              <div className="office-image">
                <img src="https://wemust-nest.s3.ca-central-1.amazonaws.com/1770891055869_2.png" alt="Head Office" />
              </div>
              <div className="office-item-content">
                <div className="office-number">01</div>
                <div className="office-content">
                  <h3 className="office-title">Head Office</h3>
                  <p className="office-address">
                    {"495 Woodward Ave Unit 3 & 4"}
                    <br />
                    Hamilton, ON L8H 6N6
                    <br />
                    Canada
                  </p>

                </div>
              </div>
            </div>


            <div className="office-item">


              <div className="office-image">
                <img src="https://wemust-nest.s3.ca-central-1.amazonaws.com/1770891072516_We_Must_Buildings.png" alt="Head Office" />
              </div>
              <div className="office-item-content">
                <div className="office-number">02</div>
                <div className="office-content">
                  <h3 className="office-title">British Columbia</h3>
                  <p className="office-address">
                    12940 80 Avenue
                    <br />
                    Unit 102
                    <br />
                    Surrey, BC V3W 3B2
                    <br />
                    Canada
                  </p>

                </div>
              </div>
            </div>

            <div className="office-item">


              <div className="office-image">
                <img src="https://wemust-nest.s3.ca-central-1.amazonaws.com/1770891048210_1.png" alt="Head Office" />
              </div>
              <div className="office-item-content">
                <div className="office-number">03</div>
                <div className="office-content">
                  <h3 className="office-title">United States</h3>
                  <p className="office-address">
                    365 Lang Boulevard, Grand Island, NY 14072 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </p>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section >
    </>
  );
};

export default CreativePowerSection;
